export type MessagingProvider = 'buzz' | 'mattermost'

export function resolveMessagingProvider(value?: string, fixtureRoute = false): MessagingProvider {
  return fixtureRoute || value === 'buzz' ? 'buzz' : 'mattermost'
}
